module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service_repair.field.repair_result_reason.placeholder":"ระบุปัญหาที่เจอคร่าว ๆ","service_repair_result.reasons.1":"ไม่สามารถซ่อมได้","service_repair_result.reasons.2":"อะไหล่ไม่พอ","service_repair_result.reasons.3":"ไม่พบปัญหา ตามลูกค้าแจ้ง","service_repair_result.reasons.4":"ลูกค้าต้องการนำเครื่องไปใช้ก่อน","service_repair_result.reason.display":"( เนื่องจาก {reason} )"}}')
  delete Component.options._Ctor
}
